<script setup lang="ts">
import { formatPlaceContact } from "../../package/helpers/contacts-format";
import { usePlaceStore } from "@/modules/place-module";
import { computed } from "vue";
const placeStore = usePlaceStore();
const place = computed(() => placeStore.place);
</script>

<template>
  <div class="feedback-contacts">
    <a
      v-for="(contact, index) in place?.place.feedback_contacts"
      :key="index"
      :href="formatPlaceContact(contact)?.link"
      target="_blank"
    >
      <component :is="formatPlaceContact(contact).icon" />
      {{ formatPlaceContact(contact).text }}
    </a>
  </div>
</template>

<style scoped lang="scss">
.feedback-contacts {
  @media (max-width: 767px) {
    padding: 0 0 calc($base-space * 6);
  }
  > a {
    display: grid;
    grid-template-columns: 20px 1fr;
    align-items: center;
    gap: calc($base-space * 2);
    color: var(--color-semantic-content-normal-primary);
    @include body-m();
    word-break: break-word;
    padding: calc($base-space * 2) 0;

    > .icon {
      width: 20px;
      height: 20px;
      background-color: var(--color-semantic-content-normal-tertiary);
    }
  }
}
</style>
